import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageBackground from "@/components/PageBackground";
import ScrollReveal from "@/components/ScrollReveal";
import SEO from "@/components/SEO";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      <PageBackground />
      <div className="relative z-10">
      <SEO title="Impressum – 4Facemedia" description="Impressum der Kreativagentur 4Facemedia, Bochum. Angaben gemäß § 5 TMG." path="/impressum" />
      <Header />

      <section className="pt-32 pb-20 bg-gradient-hero">
        <div className="container mx-auto px-4">
          <ScrollReveal>
            <h1 className="text-5xl md:text-7xl font-bold text-foreground mt-4 mb-6">
              Impressum
            </h1>
          </ScrollReveal>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4 max-w-3xl">
          <ScrollReveal>
            <div className="prose prose-invert max-w-none space-y-8 text-foreground/85 font-light leading-relaxed">
              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">Angaben gemäß § 5 TMG</h2>
                <p>
                  Lorenz Wieschemann<br />
                  handelnd unter „4FACEMEDIA“<br />
                  Karl Leich Straße 7a<br />
                  44805 Bochum
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">Kontakt</h2>
                <p>
                  Telefon: +49 173 235 4407<br />
                  E-Mail: info@4facemedia.de
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                <p>
                  Lorenz Wieschemann<br />
                  handelnd unter „4FACEMEDIA“<br />
                  Karl Leich Straße 7a<br />
                  44805 Bochum
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">Haftungsausschluss</h2>
                <h3 className="text-lg font-medium text-foreground mb-2">Haftung für Inhalte</h3>
                <p>
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-medium text-foreground mb-2">Haftung für Links</h3>
                <p>
                  Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">Urheberrecht</h2>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <Footer />
      </div>
    </div>
  );
};

export default Impressum;
